import React from 'react';
import { formatAffairAmount, formatAffairDate } from '../../affairs/affairFormatters';
import { getAffairStage } from '../../affairs/affairModel';
import PartnerRelatedItemsTable from './PartnerRelatedItemsTable';

const columns = [
  { key: 'code', label: 'Code', render: (row) => row.code || '—' },
  { key: 'name', label: 'Nom', render: (row) => row.name || '—' },
  { key: 'stage', label: 'Étape', render: (row) => getAffairStage(row.stage)?.label || row.stage || '—' },
  { key: 'amount', label: 'Montant potentiel', render: (row) => formatAffairAmount(row.estimatedAmount || row.estimated_amount) },
  { key: 'deadline', label: 'Échéance', render: (row) => formatAffairDate(row.responseDeadline || row.response_deadline) },
  { key: 'owner', label: 'Responsable', render: (row) => row.ownerName || row.owner_name || row.ownerUserId || row.owner_user_id || '—' },
];

export default function PartnerAffairsPanel({ rows, onNavigate }) {
  return <section className="partner-section"><PartnerRelatedItemsTable rows={rows} columns={columns} onOpen={(row) => onNavigate(`/affaires/${row.id}`)} emptyMessage="Aucune affaire liée." /></section>;
}
